import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { TOTAL_INCOME_STRUCTURE_ID } from 'src/Enum/IncomeStructure';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import { findMasterDataById } from '../utils';
import ExportIncomeYearFieldsForm from './ExportIncomeYearFieldsForm';

const ExportIncomeTotalForm = () => {
  const { exportIncome } = useIncomeStructure();

  const totalExportIncome = findMasterDataById(
    exportIncome,
    TOTAL_INCOME_STRUCTURE_ID.TOTAL_EXPORT_INCOME
  );

  return (
    <>
      {totalExportIncome && (
        <Flex width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right', fontWeight: 800 }} required>
              {totalExportIncome.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (พันบาท)
            </Typography>
          </Box>
          <ExportIncomeYearFieldsForm
            keyItem={totalExportIncome.id.toString()}
          />
        </Flex>
      )}
    </>
  );
};

export default ExportIncomeTotalForm;
